'use strict';

import React from 'react'

import HolidaysMessage from '@/HolidaysMessage'
import ECUsersStats    from '@/Stats/ECUsersStats'

import PageWrapper from '@Layout/PageWrapper'
import Layout      from '@Layout/ECFront'

export default PageWrapper(function ECStatsPage (props)
{
	return (
		<Layout page_title="Reporting" history={ props.history }>

			<div className="page-content">
				<HolidaysMessage />

				<ECUsersStats />
			</div>

		</Layout>
	);
});